import React from 'react';
import { connect } from 'react-redux';

import cityChange from '../../../lib/actions/cityChange';
import { validationsSelector } from '../../../lib/selectors';
import {
  manualInputsSelector,
  inputsSelector,
} from '../../../lib/selectors/home-affordability-calculator-selectors';
import {
  HomeAffordabilityInput,
  debouncedTrackOnChange,
} from '../../../lib/utils';
import LocationAutoComplete from '../../location-autocomplete/location-autocomplete';
import { debouncedTrackInputEvent } from '../../../lib/analytics/trackers';
import useAnalytics from '../../../lib/analytics/use-analytics';

const PurchaseLocationInput: React.FC<HomeAffordabilityInput> = ({
  manualInputs,
  inputs,
  dispatch,
  label,
  analytics,
}) => {
  const segmentAbstract = useAnalytics();
  const analyticsEnabled = analytics && analytics?.enabled;
  const bedrockAnalytics =
    analyticsEnabled && analytics?.payload?.bedrock?.eventType;

  const onInputChange = (value) => {
    const { city, zip } = value;
    const trackingValue = `${city}${zip ? ` (${zip})` : ''}`;

    let bedrock;
    if (bedrockAnalytics) {
      const bedrockProps = analytics?.payload?.bedrock;
      bedrock = {
        ...bedrockProps,
        valueFieldName: 'value_s',
      };
    }

    // segment analytics
    debouncedTrackInputEvent(
      {
        field_type: 'user_type_input',
        entityName: 'city',
        field_value: city,
        field: 'City',
      },
      segmentAbstract
    );

    debouncedTrackOnChange({
      bedrock,
      validation: { valid: true },
      value: trackingValue,
    });

    dispatch(cityChange(value, 'purchaseAddress'));
  };

  return (
    <LocationAutoComplete
      data={manualInputs}
      enableTracking={false}
      label={label}
      key="hac-location-autocomplete"
      onChange={onInputChange}
      placeholder={`${inputs.purchaseAddress.city}, ${inputs.purchaseAddress.state}`}
      trackingFormName="onboarding"
    />
  );
};

const mapStateToProps = (state) => ({
  manualInputs: manualInputsSelector(state),
  inputs: inputsSelector(state),
  validations: validationsSelector(state),
});

export default connect(mapStateToProps)(PurchaseLocationInput);
